import { render, staticRenderFns } from "./ShowSuccessResult.vue?vue&type=template&id=255196bc&"
import script from "./ShowSuccessResult.vue?vue&type=script&lang=js&"
export * from "./ShowSuccessResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports